import { takeEvery, put, call } from 'redux-saga/effects';
import { GET_PRIORITY_ORDERS, GET_ACRHIVE_PRIORITY_ORDERS, GET_SPEC_PRIORITY_ORDERS, GET_HISTORY } from './actionTypes';
import {
  getPriorityOrdersSuccess,
  getPriorityOrdersFail,
  getArchivePriorityOrdersSuccess,
  getArchivePriorityOrdersFail,
  getSpecPriorityOrdersSuccess,
  getSpecPriorityOrdersFail,
  getHistoryDataSuccess,
  getHistoryDataFail,
  showLoading,
  hideLoading
} from './actions';
import { getPriorityInfo, getArchive, getSpec, getHistory } from '../../helpers/backend_helper';

/*NOT SOCKET CONNECTION*/
function* fetchPriorityInfo() {
  try {
    yield put(showLoading(true));
    const response = yield call(getPriorityInfo);
    yield put(getPriorityOrdersSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(showLoading(true));
    yield put(getPriorityOrdersFail(error));
  }
}
function* getArchivePriorities({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getArchive, id);
    yield put(getArchivePriorityOrdersSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(getArchivePriorityOrdersFail(error));
  }
}
function* getSpecPriorities({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getSpec, id);
    yield put(getSpecPriorityOrdersSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(getSpecPriorityOrdersFail(error));
  }
}
function* fetcHistoryData({ payload: id }) {
  try {
    yield put(showLoading(true));
    const response = yield call(getHistory, id);
    yield put(getHistoryDataSuccess(response));
    yield put(hideLoading(false));
  } catch (error) {
    yield put(getHistoryDataFail(error));
  }
}
/*NOT SOCKET CONNECTION*/
function* prioritySaga() {
  yield takeEvery(GET_PRIORITY_ORDERS, fetchPriorityInfo);
  yield takeEvery(GET_ACRHIVE_PRIORITY_ORDERS, getArchivePriorities);
  yield takeEvery(GET_SPEC_PRIORITY_ORDERS, getSpecPriorities);
  yield takeEvery(GET_HISTORY, fetcHistoryData);
}

export default prioritySaga;
